import { useEffect, useState } from 'react'
import Modal from '../../../core/components/UI/Modal'
import useMineralsActions from '../../hooks/useMineralsActions'
import LoaderMineralCountriesList from './LoaderMineralCountriesList'
import ModalMineralCountriesList from './ModalMineralCountriesList'

export default function ModalMineralCountries({ isOpen, onClose, mineralId }) {
  const { getCountries } = useMineralsActions()
  const [countries, setCountries] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  async function fetchCountries(mineralId) {
    try {
      setIsLoading(true)
      const countries = await getCountries(mineralId)
      setCountries(countries)
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (isOpen) {
      fetchCountries(mineralId)
    }
  }, [mineralId, isOpen])

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={`w-full border-2 border-muted-500 bg-white lg:w-10/12 xl:w-1/2`}
    >
      <div className="flex h-96 flex-col gap-2 overflow-y-auto p-2">
        {isLoading ? (
          <LoaderMineralCountriesList />
        ) : (
          <ModalMineralCountriesList
            countries={countries}
            mineralId={mineralId}
            fetchCountries={fetchCountries}
          />
        )}
      </div>
    </Modal>
  )
}
